/**
 * ! ATENÇÃO
 *
 * TODOS OS MODAIS DEVEM SER EXPORTADOS DINAMICAMENTE DE FORMA ASSINCRONA.
 *
 * @example export const MyModal = register(() => import("./MyAsyncComponent.vue"))
 */


import { AsyncComponentLoader, defineAsyncComponent } from "vue"

function register<T>(loader: AsyncComponentLoader<T>) {
  return defineAsyncComponent({ loader });
}

// Common
export const ModalConfirm = register(() => import("./ModalConfirm.vue"))

// Settings
export const ModalDeleteSite = register(() => import("./ModalDeleteSite.vue"))
export const ModalMemberCreate = register(() => import("./ModalMemberCreate.vue"))
export const ModalExportMemberReport = register(() => import("./ModalExportMemberReport.vue"))
export const ModalTestWebhook = register(() => import("./ModalTestWebhook.vue"))
export const ModalDeleteWebhook = register(() => import("./ModalDeleteWebhook.vue"))
export const ModalDeleteBanner = register(() => import("./ModalDeleteBanner.vue"))
export const ModalDominio = register(() => import("@/pages/configuration/components/ModalDominio.vue"))
export const DomainSidebar = register(() => import("@/pages/configuration/components/DomainSidebar.vue"))
export const EmblemsSidebar = register(() => import("@/pages/gamification-config/components/EmblemsSidebar.vue"))
export const ModalTermosConfig = register(() => import("@/pages/configuration/components/ModalTermosConfig.vue"))
export const ModalFirstAccessConfig = register(() => import("@/pages/configuration/components/ModalFirstAccessConfig.vue"))
export const ModalWebhooks = register(() => import("@/pages/configuration/components/ModalWebhooks.vue"))
export const ModalConfigPainel = register(() => import("@/pages/configuration/components/ModalConfigPainel.vue"))
export const ModalHideCourses = register(() => import("@/pages/configuration/components/ModalHideCourses.vue"))

// Live Lessons
export const CreateLiveLessonModal = register(() => import("./CreateLiveLessonModal.vue"))
export const CreateLiveLessonFeedbackModal = register(() => import("./CreateLiveLessonFeedbackModal.vue"))
export const ModalDeleteLiveLesson = register(() => import("./ModalDeleteLiveLesson.vue"))
export const DatePickerModal = register(() => import("./DatePickerModal.vue"))

// Comments
export const ModalDeleteComment = register(() => import("./ModalDeleteComment.vue"))

// Conditional Links
export const ModalConditionalLinksDiscard = register(() => import("./ModalConditionalLinksDiscard.vue"))
export const ModalConditionalLinksDelete = register(() => import("./ModalConditionalLinksDelete.vue"))
export const ModalConditionalLinks = register(() => import("./ModalConditionalLinks.vue"))

// Certificates
export const ModalCertificateAvailable = register(() => import("./ModalCertificateAvailable.vue"))
export const ModalNewCertificate = register(() => import("./ModalNewCertificate.vue"))

// Tutor
export const ModalTutorOnlineHistoryRename = register(() => import("./ModalTutorOnlineHistoryRename.vue"))
export const ModalTutorOnlineHistoryDelete = register(() => import("./ModalTutorOnlineHistoryDelete.vue"))

// App
export const ModalTermsOfUseAdvice = register(() => import("./ModalTermsOfUseAdvice.vue"))
export const ScheduledMaintenance = register(() => import("./ScheduledMaintenance.vue"))
export const FirstAccessModal = register(() => import("./FirstAccessModal.vue"))
export const TermsOfUseModal = register(() => import("./TermsOfUseModal.vue"))

// Upload
export const MediaManagement = register(() => import("@/components/common/MediaManagement/MediaManagement.vue"))
export const MediaManagementPreview = register(() => import("@/components/common/MediaManagementPreview/MediaManagementPreview.vue"))

// Showcase
export const ModalBuy = register(() => import("./ModalBuy.vue"))

export const ModalSale = register(() => import("./ModalSale.vue"))
export const ModalUnavailable = register(() => import("./ModalUnavailable.vue"))

// Course Config
export const ModalCategoria = register(() => import("./ModalCategoria.vue"))

// Member
export const ModalAssociationMember = register(() => import("./ModalAssociationMember.vue"))
export const ModalCourseProgress = register(() => import("@/pages/member/components/ModalCourseProgress.vue"))

// Gamification
export const AboutGamificationConfigureModal = register(() => import("@/pages/gamification/components/AboutGamificationConfigureModal.vue"))
export const DeactivateGamificationModal = register(() => import("@/pages/gamification-config/components/DeactivateGamificationModal.vue"))
export const MedalsSidebar = register(() => import("@/pages/member/components/GamificationMedalsSidebar/GamificationMedalsSidebar.vue"))
export const StudentGamificationInfoModal = register(() => import("@/components/common/StudentGamificationInfoModal/StudentGamificationInfoModal.vue"))

// Others
export const ModalMyPurcharses = register(() => import("./ModalMyPurcharses.vue"))
export const ModalProfilePicCropie = register(() => import("./ModalProfilePicCropie.vue"))
export const FeedbackModalPlay = register(() => import("./FeedbackModalPlay.vue"))
export const ModalDominion = register(() => import("@/pages/configuration/components/ModalDominio.vue"))

// Config Class Form
export const ModalDeletarTelegram = register(() => import("./ModalDeletarTelegram.vue"))
export const ModalIntegracaoTelegram = register(() => import("./ModalIntegracaoTelegram.vue"))
export const ModalComunidade = register(() => import("./ModalComunidade.vue"))
export const ModalUploadPreview = register(() => import("@/components/common/MediaManagementPreview/MediaManagementPreview.vue"))

export const ComboFormModal = register(() => import("@/pages/combos/components/ComboFormModal.vue"))

export const MyPlataformsSidebar = register(() => import("@/components/common/MyPlataformsSidebar/MyPlataformsSidebar.vue"))


